import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Spin } from 'antd';

/**
 * Button component.
 * @param param0 
 * @returns 
 */
export const LoadingOverlay: React.FunctionComponent<{
    isLoading: boolean;
}> = function ({isLoading}) {

    const getClass = () => {
        if(isLoading === true){
            return ""
        }else{
            return "d-none"
        }
    }

    return (
        <div id="loading-overlay" className={"oa-loading-overlay " + getClass()}>
            {/* <FontAwesomeIcon className="loading-icon" spin={true} icon={faSpinner}></FontAwesomeIcon> */}
            <Spin />
        </div>
    );
}
